import React, { useEffect } from 'react';
import { Bell, Gift, Megaphone, ShieldCheck, Wallet } from 'lucide-react';
import AppLoader from '../../components/modules/AppLoader';
import ModulePageHeader from '../../components/modules/ModulePageHeader';
import { useNotifications } from '../../contexts/NotificationContext';
import { getThemeColor } from '../../config/appConfig';
import { formatNotificationTime } from '../../utils/notificationData';
import '../../styles/module-shared.css';
import '../../components/notifications/notifications.css';

const THEME = getThemeColor('primary');

const typeIcon = (type = '') => {
  const key = String(type).toLowerCase();
  if (key.includes('promo') || key.includes('bonus')) return Gift;
  if (key.includes('withdraw') || key.includes('deposit') || key.includes('payout')) return Wallet;
  if (key.includes('kyc') || key.includes('verif')) return ShieldCheck;
  if (key.includes('reward') || key.includes('loyalty')) return Megaphone;
  return Bell;
};

const NotificationsPage = () => {
  const {
    notifications,
    connectionStatus,
    historyLoading,
    markAllSeen,
    markOneSeen,
    fetchHistory,
  } = useNotifications();

  useEffect(() => {
    markAllSeen();
    fetchHistory();
  }, [markAllSeen, fetchHistory]);

  return (
    <div className="page notif-page">
      <div className="page-inner">
        <ModulePageHeader
          icon={Bell}
          title="Notifications"
          subtitle={`Live status: ${connectionStatus}`}
          iconBg={`linear-gradient(135deg,${THEME},#a52a2a)`}
        />

        {historyLoading && notifications.length === 0 ? (
          <div className="module-card">
            <AppLoader color={THEME} />
          </div>
        ) : notifications.length === 0 ? (
          <div className="notif-page__empty">No notifications yet.</div>
        ) : (
          <div className="notif-page__list">
            {notifications.map((item) => {
              const Icon = typeIcon(item.type);
              return (
                <article
                  key={item.identity}
                  className={`notif-page__card${!item.isRead ? ' is-unread' : ''}`}
                  style={{ '--notif-accent': THEME }}
                  onClick={() => markOneSeen(item.identity)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') markOneSeen(item.identity);
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <span className="notif-page__card-icon" style={{ color: THEME }}>
                    <Icon className="w-5 h-5" />
                  </span>
                  <div className="notif-page__card-body">
                    <h3>{item.title}</h3>
                    {item.message ? <p>{item.message}</p> : null}
                    <div className="notif-page__meta">
                      <span>{item.type || 'General'}</span>
                      <span>{formatNotificationTime(item.createdDateTime)}</span>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationsPage;
